import { toast } from "react-toastify";
import { ReactToastifyAction, ReactToastifyDesc, ReactToastifyErrorWrapper, ReactToastifyMessage, ReactToastifySuccessWrapper, ReactToastifyWrapper } from "./styles";

interface ToastOptions {
  message: string;
  description?: string;
  action?: { link: string; title: string; target?: string };
  type: ToastType
}

export enum ToastType {
  success="success",
  error="error"
}

export const ToastMessage = ({
  message,
  description,
  action,
  type
}: ToastOptions) => {
  return (
    <ReactToastifyWrapper>
      {
        type === ToastType.success && <ReactToastifySuccessWrapper><img alt="Success" width={12} height={12} src="/assets/success-icon.svg" /></ReactToastifySuccessWrapper>
      }
      {
        type === ToastType.error && <ReactToastifyErrorWrapper><img alt="Error" width={14} height={14} src="/assets/error-icon.svg" /></ReactToastifyErrorWrapper>
      }
      <div>
        <ReactToastifyMessage>{message}</ReactToastifyMessage>
        {description && (
          <ReactToastifyDesc>{description}</ReactToastifyDesc>
        )}
        {action && (
          <ReactToastifyAction
            target={action.target}
            href={action.link}
          >
            {action.title}
          </ReactToastifyAction>
        )}
      </div>
    </ReactToastifyWrapper>
  );
};

export const reactToastify = ({
  message,
  description,
  action,
  type
}: ToastOptions) => {
  const Toast = <ToastMessage
  message={message}
  description={description}
  action={action}
  type={type}
/>
  if(type === ToastType.success) {
    return toast.success(Toast);
  }

  if(type === ToastType.error) {
    return toast.error(Toast);
  }

  return toast(Toast);
};
